export default "__VITE_ASSET__BtFA$HFI__"